import { render, staticRenderFns } from "./AddBwns.vue?vue&type=template&id=13d275cb&scoped=true&"
import script from "./AddBwns.vue?vue&type=script&lang=ts&"
export * from "./AddBwns.vue?vue&type=script&lang=ts&"
import style0 from "./AddBwns.vue?vue&type=style&index=0&id=13d275cb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d275cb",
  null
  
)

export default component.exports